import { COMPUTER_HARNESS_MODES } from '#pplx/frontend/ask-models/hooks/utilities/getSearchModelConfigQuery.js';
import { parseComputerReasoningEffort } from '#pplx/frontend/ask-models/reasoningEffort.js';
const isRecord = (value) => typeof value === 'object' && value !== null;
export const parseComputerHarnessMode = (value) => COMPUTER_HARNESS_MODES.find((mode) => mode === value) ?? null;
const parseCustomConfig = (value) => {
    if (!isRecord(value) || typeof value.orchestrator_model !== 'string')
        return null;
    const effort = parseComputerReasoningEffort(value.orchestrator_effort);
    if (!effort)
        return null;
    return {
        orchestrator_model: value.orchestrator_model,
        orchestrator_effort: effort,
    };
};
export const parseStoredComputerEffortPreferences = (value) => {
    if (!isRecord(value))
        return null;
    if (Object.hasOwn(value, 'version') && value.version !== 1)
        return null;
    if (value.version === 1) {
        const harnessMode = parseComputerHarnessMode(value.harness_mode);
        if (harnessMode &&
            value.orchestrator_model === undefined &&
            value.orchestrator_effort === undefined) {
            const preferences = { version: 1, harness_mode: harnessMode };
            return Object.keys(value).length === 2 ? value : preferences;
        }
        const custom = parseCustomConfig(value);
        if (custom && value.harness_mode === undefined) {
            const preferences = { version: 1, ...custom };
            return Object.keys(value).length === 3 ? value : preferences;
        }
        return null;
    }
    const legacy = value;
    if (legacy.active === 'custom') {
        const custom = parseCustomConfig(legacy.custom);
        return custom ? { version: 1, ...custom } : null;
    }
    const harnessMode = parseComputerHarnessMode(legacy.harnessMode);
    return legacy.active === 'simple' && harnessMode
        ? { version: 1, harness_mode: harnessMode }
        : null;
};
export const serializeStoredComputerEffortPreferences = (preferences) => {
    if (preferences.harness_mode !== undefined) {
        return {
            ...preferences,
            active: 'simple',
            harnessMode: preferences.harness_mode,
            custom: null,
        };
    }
    const custom = {
        harness_mode: 'standard',
        orchestrator_model: preferences.orchestrator_model,
        orchestrator_effort: preferences.orchestrator_effort,
    };
    return {
        ...preferences,
        active: 'custom',
        // The legacy shape requires a dormant preset for when Custom is exited.
        harnessMode: 'standard',
        custom,
    };
};
// TODO: Remove this conversion once the backend returns ComputerModeConfig.
export const getActiveThreadComputerModeFromSelection = (selection) => {
    if (!selection)
        return null;
    const harnessMode = selection.harness_mode
        ? parseComputerHarnessMode(selection.harness_mode)
        : null;
    const orchestratorEffort = parseComputerReasoningEffort(selection.reasoning_effort);
    if (selection.model_preference && orchestratorEffort) {
        return {
            version: 1,
            orchestrator_model: selection.model_preference,
            orchestrator_effort: orchestratorEffort,
        };
    }
    return harnessMode ? { version: 1, harness_mode: harnessMode } : null;
};
//# sourceMappingURL=computerModeConfigSerializer.js.map